
import { Component, Prop, Watch, Emit, FormComponentBase, $util } from "@/lib";
@Component({ name: "hi-datepicker" })
export default class HiDatepicker extends FormComponentBase {
  @Prop({
    required: true,
    default: null,
  })
  value: any;
  @Prop({ type: String, default: "date" }) type: string; //类型  date、daterange、year
  @Prop({ type: String, default: "yyyy-MM-dd" }) format: string; //格式
  @Prop({ type: Object }) options: any;
  @Prop({ type: Boolean, default: true }) clearable: boolean; // 是否显示清除按钮

  get requiredRule() {
    return {
      required: true,
      message: this.L("Validate.PleaseSelect", this.L(this.labelKey)),
      trigger: "change",
      pattern: /.+/,
    };
  }

  change(value) {
    if (this.type == "date" || this.type == "month" || this.type == "datetime") {
      this.$emit("input", value ? $util.format.date(value, this.format) : null);
    } else this.$emit("input", value ? value : null);

    this.$emit("on-change", value);
  }
}
